module.exports = __webpack_public_path__ + "img/7.c7057d95.jpg";